import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const polarisSettingsDatesRoute: InvariantJiraRoute = {
	name: 'polaris-settings-dates',
	path: '/jira/settings/products/jira-product-discovery/dates',
	exact: true,
};
